<template>
    <div id="item_page">
      <div class="centered" v-if="loaded">

        <div class="row">
            <div id="content_side">

              <div id="chat_wrapper">
                <div class="inner">
                <div class="msg" v-for="msg_item in messages" v-text="msg_item.content" :key="msg_item.id"></div>
                </div>
              </div>
              <div class="content_foot">
                <div class="pic" :style="'background-image:url(' + item.lecturers[0].pic_tumb + ');'"></div>
                <div class="title">
                  <h3><span>{{item.lecturers[0].name}}</span> {{item.lecturers[0].job}}</h3>
                </div>
                <div class="col-md-4" v-html="item.lecturers[0].description + '&nbsp;'"></div>
                <div class="col-md-4"><div class="logo" :style="'background-image:url(' + item.lecturers[0].job_icon_tumb + ');'"></div></div>
                <div class="col-md-4"><a class="btn zoom_btn">לצפייה דרך זום</a></div>

                <div id="send_msg_area">
                  <form @submit.prevent="send_message()">
                  <input type="text" v-model="new_message" placeholder="יש לך שאלה למרצה?"><input type="submit" value="שלח">
                  </form>
                </div>
              </div>


            </div>
            <div id="video_side">
              <div id="video_wrapper">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/PSJ44N16-tk" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                
                <h1 v-text="item.title"></h1>
              </div>
            </div>
        </div>

        <div class="footer">
          logos
        </div>

      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      loaded: false,
      is_test: false,
      currtime: Math.floor(Date.now() / 1000),
      id: this.$route.params.id,
      item: [ ],
      messages: [],
      new_message: ''
    };
  },
  created() {

    var self = this;
     if(this.is_test) this.currtime = 1600245900;
     
    
    if (!this.is_test)
    {
      setInterval(function(){
          self.currtime = Math.floor(Date.now() / 1000);
      }, 5*1000);
    }
    // categories 
    this.api_call({ url: 'events/get', data: { id: this.id}, onComplete: function(data){

      self.item = data.data.data;
      self.messages = data.data.data.chat;
      self.loaded = true;
      self.chat_scroll_down();
    } } );

    
    this.$pnSubscribe({
        channels: ['psg'],
    });

        
    this.$pnGetMessage('psg', this.parse_updates);


  },
  methods: {
  
    send_message() {
      var self = this;
      var msg = this.new_message;
      this.new_message = '';

          self.add_message(msg);
          self.chat_scroll_down();

       this.api_call({ url: 'chat/add', data: { key: 'e' + this.id, content: msg}, onComplete: function(){

        } } );

    },
    add_message(msg){
      this.messages.push({ content: msg });
    },
    chat_scroll_down(){
      setTimeout(() => {
      var container = this.$el.querySelector("#chat_wrapper");
      container.scrollTop = container.scrollHeight;  
      }, 10);
      
    },
    
    parse_updates(msg)
    {
      var data = JSON.parse(msg.message);
      console.log(data);

      switch(data.mtype)
      {
        case 'update_time': { 
          if (data.data.id == this.data.id) this.item = data.data;
          break; 
        }
        case 'refresh_page': { document.location.reload();  break; }
        case 'alert': { alert(data.data);  break; }
        case 'chat_msg': {
          if (data.data.keycode == 'e' + this.id) this.add_message(data.data.content);
           break; 
        }
      }
    },

  }
}
</script>